import Debug from './_debug';
import $ from 'jquery';
import MarkerClusterer from "@google/markerclusterer/dist/markerclusterer.umd"

let InteractiveMap = {};
InteractiveMap.themeUrl = $('.site-logo').parent().attr('href'); 
InteractiveMap.apiPath = '../wp-json/wp/v2/';
InteractiveMap.centers = [];
InteractiveMap.allCenters = [];
InteractiveMap.categories = [];
InteractiveMap.pathologiesId;
InteractiveMap.enfantAdulteId;
InteractiveMap.structureId;
InteractiveMap.categoryIdForReferenceCenter;
InteractiveMap.categoryIdForSkillsCenter;
InteractiveMap.isMobileSidebarActive = false;


InteractiveMap.initialize = () => {
  Debug.log('InteractiveMap: initialize');

  if ($('#interactive-map').length > 0 /*&& $('#interactive-map').children().length > 1*/) {
    InteractiveMap.fetch(InteractiveMap.getSearchQuery()).done(_ => {
      InteractiveMap.allCenters = InteractiveMap.centers;
      //console.log('InteractiveMap.allCenters: ', InteractiveMap.allCenters);
      InteractiveMap.render();
    });    
    InteractiveMap.onNavigationButtonClick();
    InteractiveMap.onFiltersSubmitButtonClick();
    InteractiveMap.automaticSearchOnCheckboxes();
  }
}

InteractiveMap.automaticSearchOnCheckboxes = _ => {
  $(".custom-checkbox input").change(_ => {
    InteractiveMap.filterData();

    window.setTimeout(_ => {
      if ($('.interactive-map-infos-results').hasClass('d-none')) {
        $('.interactive-map-infos-no-results').toggleClass('d-none');
        $('.interactive-map-infos-results').toggleClass('d-none');
        $('.interactive-map-infos').toggleClass('d-none');
      }
      InteractiveMap.toggleMobileSidebar();
      InteractiveMap.isMobileSidebarActive = false;
    }, 1000);
  });
}

//FETCH DATA
InteractiveMap.fetch = (query) => {
  Debug.log('InteractiveMap: fetch');

  let url = InteractiveMap.apiPath + 'categories?per_page=100';
  let deferred = $.Deferred();

  $.get( url, (categories) => {
    InteractiveMap.categories = categories;
    InteractiveMap.getCategoriesIds();

    url = InteractiveMap.apiPath + 'centres?' + query;
    $.get( url, (centers) => {
      InteractiveMap.centers = centers;
      deferred.resolve();
    });
  });
  return deferred;
}

//RENDER
InteractiveMap.render = () => {
  Debug.log('InteractiveMap: render');
  InteractiveMap.renderMap();
  InteractiveMap.renderList();  
  InteractiveMap.renderInfosResults();
}

InteractiveMap.getMarkerImageUrlDependingOnTheStructureCategory = (center) => {
  let imageName = 'marker-green.png';
  if (InteractiveMap.isCategoryIncluded(center.categories, InteractiveMap.categoryIdForPulmotension)) {
    imageName = 'marker-pink.png'
  }
  if (InteractiveMap.isCategoryIncluded(center.categories, InteractiveMap.categoryIdForRespirare)) {
    imageName = 'marker-blue.png'
  }  
  return InteractiveMap.themeUrl + '/wp-content/themes/respifil/dist/images/' + imageName; 
}

InteractiveMap.renderInfosResults = function() {
  $('.interactive-map-infos-results').html(InteractiveMap.getInfosResultsHtml());
};

InteractiveMap.getInfosResultsHtml = function() {
  let html = '';
  html += '<div><strong>' + InteractiveMap.centers.length + ' résultat(s) pour votre recherche</strong></div>';
  html += '<div>' + InteractiveMap.getFiltersHtml () + '</div>';
  html += '<a href="." role="button" class="btn icon-left mt-4">';
  html += '<span class="icon-respifil-arrow-right"></span>';
  html += '  Réinitialiser les filtres';
  html += '</a>';
  
  return html;
};


//CATEGORIES
InteractiveMap.getCategoryIdFromSlug = function(slug) {
  let categoryId = '';
  InteractiveMap.categories.forEach(category => {
    if (category.slug == slug) {
      categoryId = category.id;
      return false;
    }
  });
  return categoryId;
}; 

InteractiveMap.getCategoriesIds = function() {
  InteractiveMap.categoryIdForReferenceCenter = InteractiveMap.getCategoryIdFromSlug('centre-de-reference');
  InteractiveMap.categoryIdForSkillsCenter = InteractiveMap.getCategoryIdFromSlug('centre-de-competence');
  InteractiveMap.pathologiesId =  InteractiveMap.getCategoryIdFromSlug('maladies');
  InteractiveMap.enfantAdulteId = InteractiveMap.getCategoryIdFromSlug('enfant-adulte');
  InteractiveMap.structureId = InteractiveMap.getCategoryIdFromSlug('type-de-structure');
  InteractiveMap.categoryIdForOrphalung = InteractiveMap.getCategoryIdFromSlug('maladies-pulmonaires-rares-centres-orphalung');
  InteractiveMap.categoryIdForPulmotension = InteractiveMap.getCategoryIdFromSlug('hypertension-pulmonaire-centres-pulmotension');
  InteractiveMap.categoryIdForRespirare = InteractiveMap.getCategoryIdFromSlug('maladies-respiratoires-rares-centres-respirare');
  InteractiveMap.categoryIdForTransitionEnfantAdulte = InteractiveMap.getCategoryIdFromSlug('transition-enfant-adulte');

  Debug.log('categoryIdForReferenceCenter: ' + InteractiveMap.categoryIdForReferenceCenter);
  Debug.log('categoryIdForSkillsCenter: ' + InteractiveMap.categoryIdForSkillsCenter);
  Debug.log('pathologiesId: ' + InteractiveMap.pathologiesId);
  Debug.log('enfantAdulteId: ' + InteractiveMap.enfantAdulteId);
  Debug.log('structureId: ' + InteractiveMap.structureId);
  Debug.log('categoryIdForOrphalung: ' + InteractiveMap.categoryIdForOrphalung);
  Debug.log('categoryIdForPulmotension: ' + InteractiveMap.categoryIdForPulmotension);
  Debug.log('categoryIdForRespirare: ' + InteractiveMap.categoryIdForRespirare);
  Debug.log('categoryIdForTransitionEnfantAdulte: ' + InteractiveMap.categoryIdForTransitionEnfantAdulte);

}; 

//NAVIGATION
InteractiveMap.toggleListMap = function() {
  $('#interactive-map-navigation .btn-list').toggleClass('active');
  $('#interactive-map-wrapper-list').toggleClass('d-none');
  $('#interactive-map-navigation .btn-map').toggleClass('active');
  $('#interactive-map-wrapper-map').toggleClass('d-none');
}; 

InteractiveMap.toggleMobileSidebar = function() {
  $('.page-template-template-page-ou-consulter .sidebar').toggleClass('d-none');
}; 

InteractiveMap.onNavigationButtonClick = function() {
  $('#interactive-map-navigation button').on('click', function() {
    InteractiveMap.toggleListMap();
  });
  $('.sidebar-interactive-map .mobile-close').on('click', function() {
    InteractiveMap.toggleMobileSidebar();
    InteractiveMap.isMobileSidebarActive = false;
  });
  $('.interactive-map-template .mobile-open').on('click', function() {
    InteractiveMap.toggleMobileSidebar();
    InteractiveMap.isMobileSidebarActive = true;
  });  
}; 
InteractiveMap.onFiltersSubmitButtonClick = () => {
  $('.sidebar-interactive-map button[type=submit]').on('click', function(event) {
    event.preventDefault();
    event.stopPropagation();
    InteractiveMap.filterData();

    window.setTimeout(_ => {
      if ($('.interactive-map-infos-results').hasClass('d-none')) {
        $('.interactive-map-infos-no-results').toggleClass('d-none');
        $('.interactive-map-infos-results').toggleClass('d-none');
        $('.interactive-map-infos').toggleClass('d-none');
      }
    }, 1000);    

    //scroll to h1 element
    /*$('body,html').animate({
      scrollTop: ($('h1').offset().top - 40)
    }, 600);*/

    if (InteractiveMap.isMobileSidebarActive) {
      InteractiveMap.toggleMobileSidebar();
      InteractiveMap.isMobileSidebarActive = false;
    }
  });
}

InteractiveMap.getFiltersHtml = () => {
  let html = '';
  let mc = $(".sidebar-interactive-map input[type=search]").val();
  if (mc.length > 0) {
    html += '<i>Par mot clé : </i><br/>';
    html += mc + '<br/><br/>';
  }
  let categories = $(".sidebar-interactive-map .custom-control-input:checked"); 
  if (categories.length > 0) {
    html += '<i>Centres : </i><br/>';
    categories.each(function(){
      html+= $(this).parent().find('label').text() + '<br/>';
    });
  }
  return html;
}
 
//FILTERS
InteractiveMap.filterData = () => {
  InteractiveMap.fetch(InteractiveMap.getSearchQuery()).done(_ => {
    InteractiveMap.filterCenters();
    InteractiveMap.render();
  });
}

InteractiveMap.getSearchQuery = () => {
  let query = 'search=' + $(".sidebar-interactive-map input[type=search]").val() + '&per_page=100';
  Debug.log('query: ' + query);
  return query;
}

InteractiveMap.unionCentersWithAcfTags = (centers) => {
  InteractiveMap.allCenters.forEach(center => {
    let keywords = center.acf['recherche-avancee-mc'];
    if (typeof keywords !== 'undefined' && keywords.length > 0) {
      let query = $(".sidebar-interactive-map input[type=search]").val();
      query = query.trim().replace(/, /g, ',').replace(/ ,/g, ',');
      keywords = keywords.toLowerCase();
      query = query.toLowerCase();
  
      query.split(',').forEach(keyword => {
        //console.log('acf filter for keyword [' + keyword + ']');
        if (keywords.indexOf(keyword) >=0 && InteractiveMap.isArrayContainsCenter(centers, center) === false) {
          centers.push(center);
        }
      });
    }
  });
  //console.log('filterAcfTags centers: ', centers);
  return centers;
}


InteractiveMap.filterCenters = () => {
  let isCategoriesAreIncludedInCenter = false;
  let filteredCenters = [];
  let categories = [];

  //console.log('InteractiveMap.centers before filters: ', InteractiveMap.centers);

  //acf tags filter
  InteractiveMap.centers = InteractiveMap.unionCentersWithAcfTags(InteractiveMap.centers);

  //categories filter
  let pathologiesCategoriesChecked = [];
  let enfantAdulteCategoriesChecked = [];
  let structureCategoriesChecked = [];

  let pathologiesFilteredCenters = [];
  let enfantAdulteFilteredCenters = [];
  let structureFilteredCenters = [];

  $(".sidebar-interactive-map .nav-category-" + InteractiveMap.pathologiesId + " .custom-control-input:checked").each(function(){
    pathologiesCategoriesChecked.push($(this).attr('name'));
  });
  $(".sidebar-interactive-map .nav-category-" + InteractiveMap.enfantAdulteId + " .custom-control-input:checked").each(function(){
    enfantAdulteCategoriesChecked.push($(this).attr('name'));
  });
  $(".sidebar-interactive-map .nav-category-" + InteractiveMap.structureId + " .custom-control-input:checked").each(function(){
    structureCategoriesChecked.push($(this).attr('name'));
  });

  //console.log('pathologiesCategoriesChecked: ', pathologiesCategoriesChecked);
  //console.log('enfantAdulteCategoriesChecked: ', enfantAdulteCategoriesChecked);
  //console.log('structureCategoriesChecked: ', structureCategoriesChecked);

  InteractiveMap.centers.forEach(center => {
    pathologiesCategoriesChecked.forEach(categoryId => {
      if (InteractiveMap.isCategoryIncluded(center.categories, categoryId) === true) {
        if (InteractiveMap.isArrayContainsCenter(pathologiesFilteredCenters, center) === false) {
          pathologiesFilteredCenters.push(center);
        }
      }
    });
    if (pathologiesCategoriesChecked.length === 0) {
      pathologiesFilteredCenters.push(center);
    }
  });
  //console.log('pathologiesFilteredCenters after pathologies filter: ', pathologiesFilteredCenters);
  InteractiveMap.centers.forEach(center => {
    enfantAdulteCategoriesChecked.forEach(categoryId => {
      if (InteractiveMap.isCategoryIncluded(center.categories, categoryId) === true) {
        if (InteractiveMap.isArrayContainsCenter(enfantAdulteFilteredCenters, center) === false) {
          enfantAdulteFilteredCenters.push(center);
        }
      }
    });
    if (enfantAdulteCategoriesChecked.length === 0) {
      enfantAdulteFilteredCenters.push(center);
    }
  });
  //console.log('enfantAdulteFilteredCenters after enfantadulte filter: ', enfantAdulteFilteredCenters);

  InteractiveMap.centers.forEach(center => {
    structureCategoriesChecked.forEach(categoryId => {
      if (InteractiveMap.isCategoryIncluded(center.categories, categoryId) === true) {
        if (InteractiveMap.isArrayContainsCenter(structureFilteredCenters, center) === false) {
          structureFilteredCenters.push(center);
        }
      }
    });
    if (structureCategoriesChecked.length === 0) {
      structureFilteredCenters.push(center);
    }
  });
  //console.log('structureFilteredCenters after structure filter: ', structureFilteredCenters);

  filteredCenters = pathologiesFilteredCenters;
  filteredCenters = InteractiveMap.categoriesIntersection(filteredCenters, enfantAdulteFilteredCenters);
  filteredCenters = InteractiveMap.categoriesIntersection(filteredCenters, structureFilteredCenters);
  
  //console.log('filteredCenters after intersections: ', filteredCenters);

  InteractiveMap.centers = filteredCenters;
}

InteractiveMap.categoriesIntersection = (arrA, arrB) => {
  return arrA.filter(x => {
    return InteractiveMap.isCategoryIncluded(arrB, x);
  }); 
  //return arrA.filter(x => arrB.includes(x)); //better but not suported for IE
}

InteractiveMap.isCategoryIncluded = (arrayCategories, category) => {
  let isIncluded = false;

  arrayCategories.forEach(arrayCategory => {
    if (arrayCategory == category) {
      isIncluded = true;
      return false;
    }
  });

  return isIncluded;
}

InteractiveMap.isArrayContainsCenter = (centers, centerToTest) => {
  let isIncluded = false;
  let centerToTestId = centerToTest.id;

  centers.forEach(center => {
    if (center.id === centerToTestId) {
      isIncluded = true;
      return false;
    }
  });

  return isIncluded;
}

//LIST
InteractiveMap.renderList = () => {
  Debug.log('InteractiveMap: renderList');
  let html = '';  

  let listSorted = InteractiveMap.groupListByStructureTypeAndSortByAlphabeticalOrder(InteractiveMap.centers, 'asc');
  listSorted.forEach(center => {
    html+= '<article class="center-item card">';
    html+= '<div class="card-body">';
    html+= InteractiveMap.getHeaderListDependingOnCategory(center);
    html+= '<h2 class="no-custom-title">';
    html+= InteractiveMap.getListItemTitle(center);
    html+= '</h2>';
    html+= InteractiveMap.getHtmlCity(center);
    html+= InteractiveMap.getListItemExcerpt(center);
    html+= '<a href="' + InteractiveMap.getListItemLink(center) + '" target="_blank" role="button">';
    html+= 'Voir la fiche';
    html+= '</a>';
    html+= '</div>';
    html+= '</article>';
  });

  $('#interactive-map-wrapper-list').html(html);
}

InteractiveMap.getHeaderListDependingOnCategory = (center) => {
  let html = '<div class="category">';
  if (InteractiveMap.isCategoryIncluded(center.categories, InteractiveMap.categoryIdForOrphalung)) {
    html += '<span class="icon-respifil-lung green pr-1"></span>';
    html += '<span class="text green">Orphalung</span>';
    if (InteractiveMap.isCategoryIncluded(center.categories, InteractiveMap.categoryIdForTransitionEnfantAdulte)) {
      html += '<br><span class="icon-respifil-enfant-adulte green pr-1"></span>';
      html += '<span class="text green">Transition enfant-adulte</span>';
    }
  }
  if (InteractiveMap.isCategoryIncluded(center.categories, InteractiveMap.categoryIdForPulmotension)) {
    html += '<span class="icon-respifil-lung pink pr-1"></span>';
    html += '<span class="text pink">Pulmotension</span>';  
    if (InteractiveMap.isCategoryIncluded(center.categories, InteractiveMap.categoryIdForTransitionEnfantAdulte)) {
      html += '<br><span class="icon-respifil-enfant-adulte pink pr-1"></span>';
      html += '<span class="text pink">Transition enfant-adulte</span>';
    }
  }
  if (InteractiveMap.isCategoryIncluded(center.categories, InteractiveMap.categoryIdForRespirare)) {
    html += '<span class="icon-respifil-lung blue pr-1"></span>';
    html += '<span class="text blue">Respirare</span>'; 
    if (InteractiveMap.isCategoryIncluded(center.categories, InteractiveMap.categoryIdForTransitionEnfantAdulte)) {
      html += '<br><span class="icon-respifil-enfant-adulte blue pr-1"></span>';
      html += '<span class="text blue">Transition enfant-adulte</span>';
    } 
  } 
  html += '</div>';
  return html; 
}

InteractiveMap.groupListByStructureTypeAndSortByAlphabeticalOrder = (centers, order) => {
  //group by structure type
  let arrayReference = [];
  let arrayReferenceAdult = [];
  let arrayReferenceChildren = [];
  let arrayReferenceAdultChildren = [];
  let arraySkills = [];
  let arraySkillsAdult = [];
  let arraySkillsChildren = [];
  let arraySkillsAdultChildren = [];

  /*centers.forEach(center => {
    if (InteractiveMap.isCategoryIncluded(center.categories, InteractiveMap.categoryIdForReferenceCenter)) {
      if (InteractiveMap.getListItemTitle(center).indexOf('enfant') >= 0) {
        if (InteractiveMap.getListItemTitle(center).indexOf('adulte') >= 0) {
          arrayReferenceAdultChildren.push(center);
        }
        else {
          arrayReferenceChildren.push(center);
        }
      } else {
        arrayReferenceAdult.push(center);
      }
    }
    else {
      if (InteractiveMap.getListItemTitle(center).indexOf('enfant') >= 0) {
        if (InteractiveMap.getListItemTitle(center).indexOf('adulte') >= 0) {
          arraySkillsAdultChildren.push(center);
        }
        else {
          arraySkillsChildren.push(center);
        }
      } else {
        arraySkillsAdult.push(center);
      }
    }
  });

  //sort by adult and alphabetical order
  InteractiveMap.sortListByAlphabeticalOrder(arrayReferenceAdult, order);
  InteractiveMap.sortListByAlphabeticalOrder(arrayReferenceChildren, order);
  arrayReference = arrayReferenceAdult.concat(arrayReferenceChildren); 

  InteractiveMap.sortListByAlphabeticalOrder(arraySkillsAdult, order);
  InteractiveMap.sortListByAlphabeticalOrder(arraySkillsChildren, order);
  arraySkills = arraySkillsAdult.concat(arraySkillsChildren);*/
  
  centers.forEach(center => {
    if (InteractiveMap.isCategoryIncluded(center.categories, InteractiveMap.categoryIdForReferenceCenter)) {
      arrayReference.push(center);
    }
    else {
      arraySkills.push(center);
    }
  });

  InteractiveMap.sortListByAlphabeticalOrder(arrayReference, order);
  InteractiveMap.sortListByAlphabeticalOrder(arraySkills, order);  

  return arrayReference.concat(arraySkills);
}

InteractiveMap.sortListByAlphabeticalOrder = (centers, order) => {
  let orderNb = 1;
  if (order === 'desc') { orderNb = -1 }

  let sortedCenters = centers.sort((a, b) => {
    let titleAAfterAdult = InteractiveMap.getListItemTitle(a).toLowerCase().replace(/d&rsquo;/g, 'de ' );

    let indexChildren = titleAAfterAdult.indexOf(' enfant ');
    let indexAdult = titleAAfterAdult.indexOf(' adulte ');
    let indexAdultChildren = titleAAfterAdult.indexOf(' adulte et enfant ');
    let index = -1;
    let indexEndOfCity = titleAAfterAdult.indexOf('(site');
    if (indexEndOfCity < 0) {indexEndOfCity = titleAAfterAdult.length }

    //adult case
    if (indexChildren < 0 && indexAdult >=0) {
      index = indexAdult + 11;
      titleAAfterAdult = titleAAfterAdult.substring(index, indexEndOfCity) + ' 1 ';
    }

    //adult and children case
    if (indexChildren >= 0 && indexAdult >= 0) {
      index = indexAdultChildren + 21;
      titleAAfterAdult = titleAAfterAdult.substring(index, indexEndOfCity) + ' 2 ';
    }

    //children case
    if (indexChildren >= 0 && indexAdult < 0) {
      index = indexChildren + 11;
      titleAAfterAdult = titleAAfterAdult.substring(index, indexEndOfCity) + ' 3 ';
    }

    let titleBAfterAdult = InteractiveMap.getListItemTitle(b).toLowerCase().replace(/d&rsquo;/g, 'de ' );

    indexChildren = titleBAfterAdult.indexOf(' enfant ');
    indexAdult = titleBAfterAdult.indexOf(' adulte ');
    indexAdultChildren = titleBAfterAdult.indexOf(' adulte et enfant ');
    indexEndOfCity = titleBAfterAdult.indexOf('(site');
    if (indexEndOfCity < 0) {indexEndOfCity = titleBAfterAdult.length }

    //adult case
    if (indexChildren < 0 && indexAdult >=0) {
      index = indexAdult + 11;
      titleBAfterAdult = titleBAfterAdult.substring(index, indexEndOfCity) + ' 1 ';
    }

    //adult and children case
    if (indexChildren >= 0 && indexAdult >= 0) {
      index = indexAdultChildren + 21;
      titleBAfterAdult = titleBAfterAdult.substring(index, indexEndOfCity) + ' 2 ';
    }

    //children case
    if (indexChildren >= 0 && indexAdult < 0) {
      index = indexChildren + 11;
      titleBAfterAdult = titleBAfterAdult.substring(index, indexEndOfCity) + ' 3 ';
    }

    if(titleAAfterAdult < titleBAfterAdult) return orderNb*-1;
    if(titleAAfterAdult > titleBAfterAdult) return orderNb*1;
    return 0;
  }); 

  return sortedCenters;
}

InteractiveMap.getListItemTitle = (center) => {
  let html = center.title.rendered;
  return html;
}

InteractiveMap.getListItemExcerpt = (center) => {
  let html = center.content.rendered;
  const h2Index = html.indexOf('<h2');
  if (h2Index >= 0) {
    html = html.substring(0, h2Index);
  }
  return html;
}

InteractiveMap.getListItemLink = (center) => {
  return center.link;
}

//MAP
InteractiveMap.debugDoublonAndNoGeolocationsMarkers = _ => {
  let doublonMarkers = [];
  let nanMarkers = [];
  let latitude = 0;
  let longitude = 0;
  let totalCenters = 0;

  InteractiveMap.centers.forEach((center, index) => {
    latitude = parseFloat(center.acf.latitude);
    longitude = parseFloat(center.acf.longitude);
    totalCenters++;

    if (isNaN(latitude) || isNaN(longitude)){
      nanMarkers.push(InteractiveMap.getListItemTitle(center));
    }  

    InteractiveMap.centers.forEach((centerToTest, indexToTest) => {
      if (latitude === parseFloat(centerToTest.acf.latitude) &&
        longitude === parseFloat(centerToTest.acf.longitude) &&
        index !== indexToTest){
          doublonMarkers.push(InteractiveMap.getListItemTitle(centerToTest));
      }     
    });    
  });

  console.log('### TOTAL NB MARKERS ###'); 
  console.log(totalCenters); 
  console.log('############################');

  console.log('### MAPS DOUBLON MARKERS ###'); 
  console.log(doublonMarkers); 
  console.log('############################');
  
  console.log('### MAPS Nan MARKERS ###'); 
  console.log(nanMarkers); 
  console.log('############################');   
}

InteractiveMap.addMarkers = _ => {
  let bounds  = new google.maps.LatLngBounds();
  let markers = [];

  InteractiveMap.centers.forEach(center => {
    let image = {
      url: InteractiveMap.getMarkerImageUrlDependingOnTheStructureCategory(center),
      size: new google.maps.Size(36, 38),
      origin: new google.maps.Point(0, 0),
      // The anchor for this image is the base of the image.
      //anchor: new google.maps.Point(0, 0)
    };

    let marker = new google.maps.Marker({
      position: {lat: parseFloat(center.acf.latitude), lng: parseFloat(center.acf.longitude)},
      map: InteractiveMap.map,
      icon: image,
      //title: unescape(center.title.rendered),
    });
    markers.push(marker);

    let loc = new google.maps.LatLng(marker.position.lat(), marker.position.lng());
    bounds.extend(loc);

    let html = '<article class="map-info-window">';
    html+= InteractiveMap.getHeaderListDependingOnCategory(center);
    html+= '<h2 class="no-custom-title map-info-window-title">';
    html+= InteractiveMap.getListItemTitle(center);
    html+= '</h2>';
    html+= InteractiveMap.getHtmlCity(center);
    html+= '';
    html+= InteractiveMap.getListItemExcerpt(center);
    html+= '<a href="' + InteractiveMap.getListItemLink(center) + '" target="_blank" role="button">';
    html+= 'Voir la fiche';
    html+= '</a>';
    html+= '</article>'
    let infowindow = new google.maps.InfoWindow({
      content: html
    });
    marker.addListener('click', function() {
      infowindow.open(InteractiveMap.map, marker);
    });
  });

  //Manage marker clusters
  InteractiveMap.markerCluster(markers);

  //Manage map zoom and center depending on the markers
  InteractiveMap.map.fitBounds(bounds, 100);   // auto-zoom
  InteractiveMap.map.panToBounds(bounds); // auto-center
  window.setTimeout(_ => {
    if (InteractiveMap.map.getZoom() > 12) {
      InteractiveMap.map.setZoom(12);
    }
  }, 1000);

  //Debug purpose : check for doublons and no geolocations
  //InteractiveMap.debugDoublonAndNoGeolocationsMarkers();
}

InteractiveMap.getHtmlCity = (center) => {
  let html = '';
  if (typeof center.acf.ville !== 'undefined' && center.acf.ville.length > 0) {
    html += '<div class="city">' + center.acf.ville + '</div>';
  }
  return html;
}

InteractiveMap.markerCluster = (markers) => {
  const mcOptions = {
    gridSize: 20, 
    //maxZoom: 15,
    styles: [
      {
        url: '../wp-content/themes/respifil/dist/images/m/m1.png',
        width: 53,
        height:53,
        fontFamily: 'sans serif',
        textSize: 13,
        textColor: '#ffffff'
      },
      {
        url: '../wp-content/themes/respifil/dist/images/m/m2.png',
        width: 56,
        height:56,
        fontFamily: 'sans serif',
        textSize: 13,
        textColor: '#ffffff'
      },
      {
        url: '../wp-content/themes/respifil/dist/images/m/m3.png',
        width: 66,
        height:65,
        fontFamily: 'sans serif',
        textSize: 13,
        textColor: '#ffffff'
      }                             
    ]
  };
  return new MarkerClusterer(InteractiveMap.map, markers, mcOptions);
}

InteractiveMap.renderMap = _ => {
  InteractiveMap.map = new google.maps.Map(document.getElementById('interactive-map-wrapper-map'), {
    center: {lat: 46.809613, lng: 1.907728},
    zoom: 6,
    mapTypeControl: false,
    rotateControl: false,	
    streetViewControl: false,
    scaleControl: false,
    fullscreenControl: false,
    styles: [
      {
        "elementType": "geometry",
        "stylers": [
          {
            "color": "#f5f5f5"
          }
        ]
      },
      {
        "elementType": "labels.icon",
        "stylers": [
          {
            "visibility": "off"
          }
        ]
      },
      {
        "elementType": "labels.text.fill",
        "stylers": [
          {
            "color": "#616161"
          }
        ]
      },
      {
        "elementType": "labels.text.stroke",
        "stylers": [
          {
            "color": "#f5f5f5"
          }
        ]
      },
      {
        "featureType": "administrative.land_parcel",
        "elementType": "labels.text.fill",
        "stylers": [
          {
            "color": "#bdbdbd"
          }
        ]
      },
      {
        "featureType": "poi",
        "elementType": "geometry",
        "stylers": [
          {
            "color": "#eeeeee"
          }
        ]
      },
      {
        "featureType": "poi",
        "elementType": "labels.text.fill",
        "stylers": [
          {
            "color": "#757575"
          }
        ]
      },
      {
        "featureType": "poi.park",
        "elementType": "geometry",
        "stylers": [
          {
            "color": "#e5e5e5"
          }
        ]
      },
      {
        "featureType": "poi.park",
        "elementType": "labels.text.fill",
        "stylers": [
          {
            "color": "#9e9e9e"
          }
        ]
      },
      {
        "featureType": "road",
        "elementType": "geometry",
        "stylers": [
          {
            "color": "#ffffff"
          }
        ]
      },
      {
        "featureType": "road.arterial",
        "elementType": "labels.text.fill",
        "stylers": [
          {
            "color": "#757575"
          }
        ]
      },
      {
        "featureType": "road.highway",
        "elementType": "geometry",
        "stylers": [
          {
            "color": "#dadada"
          }
        ]
      },
      {
        "featureType": "road.highway",
        "elementType": "labels.text.fill",
        "stylers": [
          {
            "color": "#616161"
          }
        ]
      },
      {
        "featureType": "road.local",
        "elementType": "labels.text.fill",
        "stylers": [
          {
            "color": "#9e9e9e"
          }
        ]
      },
      {
        "featureType": "transit.line",
        "elementType": "geometry",
        "stylers": [
          {
            "color": "#e5e5e5"
          }
        ]
      },
      {
        "featureType": "transit.station",
        "elementType": "geometry",
        "stylers": [
          {
            "color": "#eeeeee"
          }
        ]
      },
      {
        "featureType": "water",
        "elementType": "geometry",
        "stylers": [
          {
            "color": "#c9c9c9"
          }
        ]
      },
      {
        "featureType": "water",
        "elementType": "labels.text.fill",
        "stylers": [
          {
            "color": "#9e9e9e"
          }
        ]
      }
    ]
  });
  InteractiveMap.addMarkers();
}

export default InteractiveMap;